module.exports = __webpack_public_path__ + "img/reference-larva.81f579a2.jpg";